module.exports = __webpack_public_path__ + "static/media/3.fd11fd55.jpg";